var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('div',{staticStyle:{"margin-bottom":"30px"}},[_vm._v("aqui va la invitacion")]),_c('qriously',{attrs:{"value":_vm.id,"size":400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }